import { ALERT_SEVERITIES, type Alert, type AlertSeverity } from '@fruuit/shared'
import { StatusBadge } from '@fruuit/ui'
import { formatDateTime, formatRelative } from '../feeds/format'

export function SeverityBadge({ severity }: { severity: AlertSeverity }) {
  return <StatusBadge status={severity} label={ALERT_SEVERITIES.labels[severity]} />
}

/** Compact alert list for the admin Overview. */
export function AlertSummaryList({ alerts }: { alerts: readonly Alert[] }) {
  return (
    <ul className="divide-y divide-line-soft">
      {alerts.map((alert) => (
        <li key={alert.id} className="flex flex-col gap-1.5 py-3 first:pt-0 last:pb-0">
          <div className="flex flex-wrap items-center gap-2">
            <SeverityBadge severity={alert.severity} />
            <span className="text-xs text-sage" title={formatDateTime(alert.created_at)}>
              {formatRelative(alert.created_at)}
            </span>
          </div>
          <p className="text-sm font-semibold leading-snug text-ink">{alert.subject}</p>
          <p className="text-xs text-sage">
            {alert.kind_label}
            {alert.provider_name ? ` · ${alert.provider_name}` : ''}
          </p>
        </li>
      ))}
    </ul>
  )
}
